import { useContext } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'

import { ModalContext } from '@/contexts/ModalContext'
import ModalAuth from '@/components/modals/ModalAuth'
import useCustomHistory from './useCustomHistory'
import { authActions } from '@/redux/actions'
import Toggles from '@domain/toggles/Toggles'
export default function useAuth() {
	const dispatch = useDispatch()
	const history = useCustomHistory()
	const userAuth = useSelector(state => state.auth, shallowEqual)
	const { modalMount } = useContext(ModalContext)

	const checkAuthentication = () => {
		return userAuth.logged
	}

	const userHasRole = (roles) => {
		const rolesList = typeof roles === 'string' ? [roles] : roles
		const matchRoles = rolesList.filter((element) => userAuth?.account?.roles?.includes(element))
		return !_.isEmpty(matchRoles)
	}

	const authenticate = async (view = '/', viewParams = {}) => {
		// Narrow the dialog only when the new auth form is active. The prop
		// flows through useModal → ModalContext → RfModal which spreads it onto
		// the inner dialog div, overriding the default 36rem width.
		const newAuthForm = Toggles.isEnabled('newAuthForm')
		const narrowModalProps = newAuthForm
			? { ModalDialogProps: { style: { width: '470px', maxWidth: '470px' } } }
			: {}
		return new Promise((resolve, reject) => {
			modalMount(
				<ModalAuth
					disableBackdropClick
					authView={view}
					authViewParams={viewParams}
					onAuth={async () => {
						await dispatch(authActions.getAccountDetails())
						resolve()
					}}
					onClose={reject}
					{...narrowModalProps}
				/>
			)
		})
	}

	const logout = async () => {
		await dispatch(authActions.logout())
		if (!Toggles.isEnabled('newProfesionalArea')) {
			history.push('/')
		}
	}

	return {
		authenticate,
		userHasRole,
		checkAuthentication,
		logout
	}
}
